import { MediaState } from "./types";

export const state: MediaState = {
  mediaList: [],
  selectMedia: null,

  isLoading: false,
  isBusy: false,
};
